// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { ImageSourcePropType } from 'react-native';

type AvatarPlayer = {
  id?: string | null;
  imageKey?: string | null;
  imageThumbKey?: string | null;
};

const avatarSourceCache = new Map<string, ImageSourcePropType>();

export const getPlayerAvatarImageSource = (apiBaseUrl: string, player: AvatarPlayer): ImageSourcePropType | null => {
  const playerId = player.id?.trim();
  const imageReference = player.imageThumbKey ?? player.imageKey ?? null;
  if (!playerId || !imageReference) {
    return null;
  }

  const normalizedBaseUrl = apiBaseUrl.replace(/\/+$/, '');
  const variant = player.imageThumbKey ? 'thumb' : 'main';
  const version = extractAvatarVersion(imageReference);
  const uri =
    `${normalizedBaseUrl}/api/players/${encodeURIComponent(playerId)}/image` +
    `?variant=${encodeURIComponent(variant)}&v=${encodeURIComponent(version)}`;

  const cached = avatarSourceCache.get(uri);
  if (cached) {
    return cached;
  }

  const source = { uri };
  avatarSourceCache.set(uri, source);
  return source;
};

const extractAvatarVersion = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'none';
  }

  try {
    const parsed = new URL(trimmed);
    const lastSegment = parsed.pathname.split('/').filter(Boolean).at(-1);
    return lastSegment ?? parsed.pathname;
  } catch {
    const lastSegment = trimmed.split('/').filter(Boolean).at(-1);
    return lastSegment ?? trimmed;
  }
};
